/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiWindowNewDownRightIcon16Light } from './UiWindowNewDownRightIcon16Light';
import { UiWindowNewDownRightIcon16Regular } from './UiWindowNewDownRightIcon16Regular';
import { UiWindowNewDownRightIcon16Solid } from './UiWindowNewDownRightIcon16Solid';
import { UiWindowNewDownRightIcon20Light } from './UiWindowNewDownRightIcon20Light';
import { UiWindowNewDownRightIcon20Regular } from './UiWindowNewDownRightIcon20Regular';
import { UiWindowNewDownRightIcon20Solid } from './UiWindowNewDownRightIcon20Solid';
import { UiWindowNewDownRightIcon24Regular } from './UiWindowNewDownRightIcon24Regular';
import { UiWindowNewDownRightIcon24Solid } from './UiWindowNewDownRightIcon24Solid';
import { UiWindowNewDownRightIcon32Regular } from './UiWindowNewDownRightIcon32Regular';
import { UiWindowNewDownRightIcon64Regular } from './UiWindowNewDownRightIcon64Regular';
var sizes = {
    16: {
        light: UiWindowNewDownRightIcon16Light,
        regular: UiWindowNewDownRightIcon16Regular,
        solid: UiWindowNewDownRightIcon16Solid,
    },
    20: {
        light: UiWindowNewDownRightIcon20Light,
        regular: UiWindowNewDownRightIcon20Regular,
        solid: UiWindowNewDownRightIcon20Solid,
    },
    24: {
        regular: UiWindowNewDownRightIcon24Regular,
        solid: UiWindowNewDownRightIcon24Solid,
    },
    32: {
        regular: UiWindowNewDownRightIcon32Regular,
    },
    64: {
        regular: UiWindowNewDownRightIcon64Regular,
    },
};
export var UiWindowNewDownRightIcon = forwardRef('UiWindowNewDownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
